<app-dialog #dialog [disableESC]="true">
  @if (dialog.shown) {
    <ng-container body>
      <div class="dialogcontent-wrapper onboarding-welcome">
        <h2 class="main-title">{{ 'onboarding.member.title' | translate: {firstName: user.firstName} }}</h2>

        <div class="dialogcontent-scroll">
        <div class="welcome-block">
          <h3 class="form-title">{{ 'onboarding.member.personal-title' | translate }}</h3>
          <ul class="welcome-list">
            @for (line of personalLines; track line) {
              <li>{{ line | translate }}</li>
            }
          </ul>
          @if (organisation) {
            <div class="welcome-actions">
              <a class="btn small accent" [routerLink]="['/organisations', 'edit', organisation.id, 'history']" target="_blank" (click)="markDone()">
                <i class="material-icons">school</i>
                <span>{{ 'onboarding.member.personal-btn' | translate: {orgName: organisation.name} }}</span>
              </a>
            </div>
          }
        </div>

        @if (organisation && role !== 'employee') {
          <div class="welcome-block">
            <h3 class="form-title">{{ 'onboarding.member.' + role + '-title' | translate: {orgName: organisation.name} }}</h3>
            <ul class="welcome-list">
              @for (line of roleLines; track line) {
                <li>{{ line | translate }}</li>
              }
            </ul>

            <div class="welcome-question">{{ 'onboarding.member.start-question' | translate: {orgName: organisation.name} }}</div>
            <div class="welcome-actions">
              <a class="btn small accent" [routerLink]="['/ows', organisation.id, 'members']" target="_blank" (click)="markDone()">
                <i class="material-icons">group</i>
                <span>{{ 'onboarding.member.' + role + '-btn-members' | translate }}</span>
              </a>
              <a class="btn small accent" [routerLink]="['/ows', organisation.id, 'learning-plans']" target="_blank" (click)="markDone()">
                <i class="material-icons">event_note</i>
                <span>{{ 'onboarding.member.' + role + '-btn-courses' | translate }}</span>
              </a>
              <a class="btn small accent" [routerLink]="['/ows', organisation.id, 'certificates']" target="_blank" (click)="markDone()">
                <i class="material-icons">workspace_premium</i>
                <span>{{ 'onboarding.member.' + role + '-btn-certificates' | translate }}</span>
              </a>
            </div>
          </div>
        }

        <!-- Was the menu's own feedback/help dialog; the help button reopens this overlay instead. -->
        <div class="welcome-block">
          <h3 class="form-title">{{ 'menu.feedback-title' | translate }}</h3>
          <div class="text" [innerHTML]="'menu.feedback-text' | translate: {email: supportEmail}"></div>
        </div>
        </div>
      </div>
    </ng-container>
  }
  <ng-container footer>
    <button type="button" class="icon-btn plain" (click)="close()" [matTooltip]="'close'|translate" matTooltipPosition="right">arrow_back</button>
  </ng-container>
</app-dialog>
